<!-- 左右表格展示 -->
<template>
  <div>
    <el-container>
      <el-aside class="width-p25">
        <basic-container>
          <el-input placeholder="输入关键字进行过滤" v-model="filterText" @change="filterFn">
          </el-input>
          <ux-grid v-loading="loading" show-overflow highlight-hover-row beautify-table height="714" row-key row-id="ID"
            ref="plxTree" :size="'small'" :show-header="true" :data="treeData" :tree-config="{
              accordion: true,
              line: true,
              iconOpen: 'el-icon-minus',
              iconClose: 'el-icon-plus',
              lazy: true,
              children: 'CHILDREN',
              hasChild: 'HAS_CHILDREN',
              loadMethod: loadChildrenMethod,
            }">
            <ux-table-column tree-node field="title" :title="title">
              <!--自定义展开部分的内容-->
              <template v-slot="{ row }">
                <div style="display:flex;">
                  <div>
                    <template v-if="row.HAS_CHILDREN">
                      <i style="margin-left: 8px" @click.stop :class="$refs.plxTree.isTreeExpandByRow(row)
                          ? 'el-icon-folder-opened'
                          : 'el-icon-folder'
                        "></i>
                    </template>
                    <template v-else>
                      <i style="margin-left: 8px" @click.stop class="el-icon-document"></i>
                    </template>
                  </div>
                  <div class="aymc-item" :class="[glID == row[zcbGlgx.parProp] ? 'active-item' : '']"
                    @click="rowClick(row)">{{ row[zbShow] }}</div>
                </div>
              </template>
            </ux-table-column>
          </ux-grid>
        </basic-container>
      </el-aside>
      <el-main>
        <Table v-if="glID" ref="table" :loadObj="{}" :dict="[]" :option="{
          tip: false,
          importBtn: true,
          selection: false,
        }" :filterObj="{
          [zcbGlgx.chilProp]: glID
        }" :colObj='{
          ...cbParams,
          importTemp: true,
          fhjdsjkYsImport: true,
          fhImportObj: {
            zbid: glID
          },
          col: [],
          addForm: {
            [zcbGlgx.chilProp]: glID
          },
        }'>
          <template slot="TOP_BUTTON">
            <slot name="TOP_BUTTON"></slot>
          </template>
          <template slot="RIGHT_BUTTON">
            <slot name="RIGHT_BUTTON"></slot>
          </template>
          <template slot="menuLeft" slot-scope="{row}">
            <slot name="menuLeft" :row="row"></slot>
          </template>
          <template slot="menuRight" slot-scope="{row}">
            <slot name="menuRight" :row="row"></slot>
          </template>
          <template slot="searchSlot" slot-scope="{query}">
            <slot name="searchSlot" :query="query"></slot>
          </template>
          <template slot="APPTIME" slot-scope="{row}">
            <slot name="APPTIME" :row="row"></slot>
          </template>
          <template slot="top">
            <slot name="top"></slot>
          </template>
          <!-- <template slot="importTemp">
                      <slot name="importTemp"></slot>
                  </template> -->
          <template slot="importTemp">
            <el-form-item label="请下载Excel数据模板">
              <el-button @click="download" type="primary">下载模板</el-button>
            </el-form-item>
          </template>
        </Table>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Table from "@/components/table/dataTablec";
import { getShow, addShow, download } from "@/api/table/table";
import treeTable from "@/components/table/treeTablec";
export default {
  components: { Table, treeTable },
  props: {
    title: { // 标题
      type: String,
      default: ''
    },
    zbParams: { // 主表参数 opid， type 等
      type: Object,
      default: () => { }
    },
    cbParams: { // 从表参数 opid， type 等
      type: Object,
      default: () => { }
    },
    ljzParams: { // 懒加载参数
      type: Object,
      default: () => { }
    },
    zbShow: { // 主表展示字段
      type: String,
      default: 'ID'
    },
    zcbGlgx: { // 主从表关联关系字段 parProp(主表字段) chilProp（从表字段）
      type: Object,
      default: () => { }
    },
    downMbObj: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      firstEnter: true,
      treeData: [],
      filterText: "",
      loading: false,
      query: {
        ZGDWID: "",
        ZGDWMC: "",
      },
      glID: '',
      selTags: ''
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 过滤树
    filterFn() {
      if (this.filterText) {
        this.onTreeLoad();
      } else {
        this.getData();
      }
    },
    // 加載树形数据
    async onTreeLoad() {
      if (!this.$route.query.runId) return;
      try {
        this.loading = true;
        let query = { [this.zbShow]: this.filterText };
        const res = await getShow(1, 9999, this.$route.query.runId, {
          obj: { ...query },
          ...this.zbParams
        });
        this.treeData = res.data.data.records;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    //获取第一级数据
    async getData() {
      if (!this.$route.query.runId) return;
      this.loading = true;
      const res = await getShow(1, 20, this.$route.query.runId, {
        extendTreeType: 2,
        ...this.zbParams
      });
      this.treeData = res.data.data.records;
      if (this.treeData.length > 0 && this.treeData[0][this.zcbGlgx.parProp]) {
        if (this.zcbGlgx.parProp) {
          this.glID = this.treeData[0][this.zcbGlgx.parProp];
        } else {
          this.$message.warning({ message: "请绑定主从表关联主表字段！！" });
        }
      } else {
        this.glID = '-1';
      }
      this.loading = false;
    },
    // 懒加载
    async loadChildrenMethod({ row }) {
      let result = await getShow(1, 9999, this.$route.query.runId, {
        obj: { [this.ljzParams.key]: row[this.ljzParams.value] },
        extendTreeType: 2,
        ...this.zbParams
      })
      return result.data.data.records;
    },
    //单击树形行
    async rowClick(row) {
      if (this.zcbGlgx.parProp) {
        this.glID = row[this.zcbGlgx.parProp];
      } else {
        return this.$message.warning({ message: "请绑定主从表关联主表字段！！" });
      }
      this.$nextTick(() => {
        this.$refs.table.$refs.child.onLoad();
      })
    },
    // 下载模板
    download() {
      download({
        filePath: this.downMbObj.path,
        fileName: `${this.downMbObj.title}.xlsx`,
      }).then(res => {
        this.downloadFun(res, `${this.downMbObj.title}.xlsx`);
      }).catch((err) => { console.log(err) })
    },
    downloadFun(res, name) {
      const blob = new Blob([res.data], {
        type: 'application/octet-stream'
      })
      let url = window.URL.createObjectURL(blob);//为文件流创建构建下载链接
      let link = document.createElement('a');//创建a标签
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);//设置a标签的下载动作和下载文件名
      document.body.appendChild(link);
      link.click();//执行下载
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);//释放标签
    },
  },
  async mounted() {
    await this.getData();
  },
  async activated() {
    if (this.firstEnter) {
      this.firstEnter = false
    } else {
      await this.getData();
      this.$refs.table.$refs.child.onLoad();
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-icon-folder-opened,
/deep/.el-icon-folder {
  color: rgb(255, 192, 1) !important;
}

.aymc-item {
  flex: 1;
  padding-left: 7px;

  &:hover {
    color: #2E5AE8;
    cursor: pointer;
  }
}

.active-item {
  color: #2E5AE8;
}

/deep/.elx-table.has--tree-line .elx-tree--btn-wrapper,
/deep/.elx-table .elx-body--row.row--current {
  background: #fff !important;
}
</style>
